import useCurrentFacility from "./useCurrentFacility";

const DEFAULT_INTERVAL = 15;

const formatDuration = (minutes: number) => {
  const mins = minutes.toString().padStart(2, "0");
  return `00:${mins}:00`;
};

export const useSlotInterval = () => {
  const currentFacility = useCurrentFacility();
  const schedulingInterval = currentFacility.data?.featureFlags?.schedulingInterval;

  const step = schedulingInterval ?? DEFAULT_INTERVAL;
  const snapDuration = formatDuration(step);

  return { step, snapDuration };
};

export default useSlotInterval;
